import { get_EmptySerializersModuleLegacyJs2imgse4bg8t49 as get_EmptySerializersModuleLegacyJs } from './SerializersModule.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function EmptySerializersModule() {
  return get_EmptySerializersModuleLegacyJs();
}
//region block: exports
export {
  EmptySerializersModule as EmptySerializersModule991ju6pz9b79,
};
//endregion

//# sourceMappingURL=SerializersModuleBuilders.mjs.map
